module.exports = {"id":"dp2_2l3q5","text":"Sharing Through Digital Technologies","instructions":"Why is it important to assess risks and benefits before sharing content digitally?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"2.2","questionType":"PickOne","random":true,"options":[{"id":"dp2_2l3q5-a1","text":"To reduce harm and maximise positive outcomes","score":3.7},{"id":"dp2_2l3q5-a2","text":"To increase engagement regardless of impact","score":1.3},{"id":"dp2_2l3q5-a3","text":"To avoid using digital services","score":1.3}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat2.2/l3q5.json
// module id = 1020
// module chunks = 41